
import { Component, Vue } from 'vue-property-decorator';
import Navbar from '@/components/Navbar.vue';
import LengthChecker from "@/components/LengthChecker.vue";
import BrowserNotSupported from "@/components/BrowserNotSupported.vue";
import LocaleSwitcher from "@/components/LocaleSwitcher.vue"

@Component({
  components: {
    Navbar,
    LengthChecker,
    BrowserNotSupported,
    LocaleSwitcher,
  },
})
export default class App extends Vue {

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
  }

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  }

  preventNav(event) {
    event.preventDefault()
    event.returnValue = ""
  }

  get browserIsExplorer():boolean {
    return  navigator.userAgent.indexOf("MSIE ") > 0 ||
      navigator.userAgent.indexOf("Trident") > 0 ||
      navigator.userAgent.indexOf("Edge") > 0;
  }
}
